'use client';

import React from 'react';
import { isChunkText, isChunkTextOrString, isKnownChunk, LlmBlock, LlmChunkItem, LlmChunkUnknownItem, sanitizeBlockType } from '../../../types';
import { useLlm } from '../../../useLlm/useLlm';

export type ChunkProps = {
  item: LlmChunkUnknownItem | LlmChunkItem;
  chunkIndex: number;
  index: number;
  total: number;
  role: string;
};

export const Chunk: React.FC<ChunkProps> = ({
  item,
  chunkIndex,
  index,
  total,
  role,
}) => {
  const blocks = useLlm(state => state.blocks);
  const messageProps = {
    chunkIndex,
    index,
    total,
    role,
    first: index === 0,
    last: index === total - 1,
  };
  const props = {
    ...messageProps,
    item,
  };
  if (isChunkTextOrString(item)) {
    const text = (isChunkText(item) ? item.text : item.content) || '';
    return text.length > 0 && (
      role === 'user' ? (
        blocks.userMessage({
          ...messageProps,
          role: 'user',
          text,
        })
      ) : (
        blocks.assistantMessage({
          ...messageProps,
          role: 'assistant',
          text,
        })
      )
    );
  }
  if (isKnownChunk(item, blocks)) {
    switch (item.type) {
      case 'image_url': {
        return item.image_url ? (
          <div className="llm__row">
            <div className="llm__col --end-xs-12 --xs-10 --sm-9 --md-8 --lg-7 --xl-6">
              <img src={item.image_url.url} alt="" />
            </div>
          </div>
        ) : (
          <code>{JSON.stringify(item)}</code>
        );
      }
      default: {
        const type = sanitizeBlockType(item.type);
        const block = blocks[type]!;
        return block(props);
      }
    }
  } else {
    return blocks.notFound(props as LlmBlock<LlmChunkUnknownItem>);
  }
};
